import * as React from 'react';

import { createIcon } from '../Icon';
export const ZapIcon = createIcon(
  <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />,
  'ZapIcon'
);
